import 'moment/locale/pt-br'
import {KTIcon} from '../../../_metronic/helpers'
import {useState} from 'react'

interface FormikMedicalEditRecord {
  Close: any
  handleSaveReason: (reason: string) => void
}

export const MedicalEditReasonModal = ({Close, handleSaveReason}: FormikMedicalEditRecord) => {
  const [editReason, setEditReason] = useState<string>('')

  return (
    <>
      <div className='modal fade show d-block'>
        <div className='modal-dialog modal-dialog-centered' style={{maxWidth: '57%'}}>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder'>Informe o motivo para alteração</h2>
              <div
                className='btn btn-icon btn-sm btn-active-icon-danger'
                data-kt-users-modal-action='close'
                onClick={() => Close()}
                style={{cursor: 'pointer'}}
              >
                <KTIcon iconName='cross' className='fs-1' />
              </div>
            </div>
            <div>
              <div className='row mb-6 m-5'>
                <h6 className='card-title mt-5 text-align-center'>Digite o Motivo</h6>
                <div className='col-12 mt-5'>
                  <div className='fv-row'>
                    <textarea
                      className='form-control form-control-solid'
                      data-kt-autosize='true'
                      id='observation '
                      value={editReason}
                      onChange={(e) => {
                        setEditReason(e.target.value)
                      }}
                      maxLength={255}
                      style={{height: '40vh'}}
                    ></textarea>
                  </div>
                  <div className='col-12 mt-6'>
                    <div className='col-12'>
                      <button type='button' className='btn btn-secondary ' onClick={() => Close()}>
                        Voltar
                      </button>
                      <button
                        type='button'
                        className='btn btn-danger ms-5'
                        disabled={editReason.length < 10}
                        onClick={(e) => {
                          e.preventDefault()
                          handleSaveReason(editReason)
                        }}
                      >
                        Salvar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}
